<template>
    <q-page class="q-pa-md">
        <q-dialog class="rounded-borders" v-model="dialogPerfilCliente" full-width>
            <q-card class="no-shadow">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Perfil del Cliente</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <perfil-cliente></perfil-cliente>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog class="rounded-borders" v-model="dialogMotivoRechazo">
            <q-card>
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Motivo de Rechazo</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <div>Describa el motivo de rechazo del documento: </div>
                    <div> {{ documentoSelect.tipo }}</div>
                    <div style="width: 400px">
                        <q-input v-model="motivoRechazo" filled type="textarea" />
                    </div>
                </q-card-section>
                <q-card-actions align="right" class="text-primary">
                    <q-btn flat label="Enviar" @click="PostRechazarDocumento()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-dialog class="rounded-borders" v-model="dialogNuevoCliente">
            <q-card v-if="form" style="width: 600px; max-width: 80vw;">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Nuevo Cliente</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <div class="row q-col-gutter-md">
                        <div class="col-12">
                            <div class="text-subtitle2">Datos del usuario </div>
                            <q-separator />
                        </div>
                        <div class="col-12">
                            <q-input dense outlined v-model="form.nombre" label="Nombre(s)" />
                        </div>
                        <div class="col-12">
                            <q-input dense outlined v-model="form.apellidos" label="Apellidos" />
                        </div>
                        <div class="col-12">
                            <q-input dense outlined v-model="form.email" label="Correo electrónico" type="email" />
                        </div>
                        <div class="col-12">
                            <q-input dense outlined v-model="form.telefono" mask="(###) ### - ####" label="Teléfono" />
                        </div>
                        <div class="col-12">
                            <div class="text-subtitle2">Datos fiscales de la persona Fisica/Moral Arrendataria </div>
                            <q-separator />
                        </div>
                        <div class="col-12 ">
                            <q-input dense outlined v-model="form.rfc" label="RFC" />
                        </div>
                        <div class="col-12  ">
                            <q-input dense outlined v-model="form.razon_social"
                                label="Razón Social o Nombre de la persona" />
                        </div>
                        <div class="col-12  ">
                            <q-input dense outlined v-model="form.cp" label="Código Postal" />
                        </div>
                        <div class="col-12 ">
                            <q-select dense class="full-width" outlined fill-input v-model="form.usoCfdi"
                                :options="usoCfdiStore" label="Uso del CFDI" option-label="usoCfdi" />
                        </div>
                        <div class="col-12  " v-if="ValidaRegimen != ''">
                            <q-select dense class="full-width" outlined fill-input v-model="form.regimen_fiscal"
                                :options="regimenFiscal" label="Régimen Fiscal" option-label="regimenFiscal" />
                        </div>
                        <div class="col-12 ">
                            <q-select dense class="full-width" outlined fill-input v-model="form.metodoPago"
                                :options="metodoPagoStore" label="Metodo de Pago" option-label="metodoPago" />
                        </div>
                        <div class="col-12 ">
                            <q-select dense class="full-width" outlined fill-input v-model="form.formaPago"
                                :options="formaPagoStore" label="Forma de Pago" option-label="formaPago" />
                        </div>
                        <div class="col-12 ">
                            <q-select dense class="full-width" outlined fill-input v-model="form.moneda"
                                :options="monedaStore" label="Moneda" option-label="moneda" />
                        </div>
                    </div>
                </q-card-section>
                <q-card-actions class="row justify-between">
                    <q-btn flat color="red" label="Cerrar" v-close-popup />
                    <q-btn flat color="primary" label="Crear Cliente" @click="PostNuevoCliente()" />
                </q-card-actions>
            </q-card>
        </q-dialog>


        <div class="row q-pt-md q-col-gutter-md">
            <div v-if="mostrarFormulario" class="col-md-4 col-12">
                <q-card class="q-pa-md text-center">
                    <div class="text-h6 q-mb-md">{{ clienteSelect.nombre + ' ' + clienteSelect.apellidos }}</div>
                    <div class="q-mb-md text-left" v-if="documentos && documentos.documento1">
                        <label class="text-subtitle2">Identificación Oficial</label>
                        <q-field :label="documentos.documento1.nombre_archivo" dense outlined
                            class="q-mt-xs full-width">
                            <template v-slot:before>
                                <q-icon v-if="documentos.documento1.existe" color="green" name="mdi-check-circle" />
                                <q-icon v-else color="red" name="mdi-alert-circle" />
                            </template>

                            <template v-slot:after>
                                <q-btn v-if="documentos.documento1.existe" round dense flat color="green"
                                    icon="mdi-download" @click="descargarArchivo(documentos.documento1)" />
                                <q-btn v-if="documentos.documento1.existe" round dense flat color="red"
                                    icon="mdi-file-remove" @click="rechazarArchivo(documentos.documento1)" />
                            </template>
                        </q-field>
                    </div>

                    <div class="q-mb-md text-left" v-if="documentos && documentos.documento2">
                        <label class="text-subtitle2">Comprobante de Ingresos</label>
                        <q-field dense outlined class="q-mt-xs full-width">
                            <template v-slot:control>
                                <div class="self-center full-width no-outline" tabindex="0">{{
                                    documentos.documento2.nombre_archivo }}</div>
                            </template>

                            <template v-slot:before>
                                <q-icon v-if="documentos.documento2.existe" color="green" name="mdi-check-circle" />
                                <q-icon v-else color="red" name="mdi-alert-circle" />
                            </template>

                            <template v-slot:after>
                                <q-btn v-if="documentos.documento2.existe" round dense flat color="green"
                                    icon="mdi-download" @click="descargarArchivo(documentos.documento2)" />
                                <q-btn v-if="documentos.documento2.existe" round dense flat color="red"
                                    icon="mdi-file-remove" @click="rechazarArchivo(documentos.documento2)" />
                            </template>
                        </q-field>
                    </div>

                    <div class="q-mb-md text-left" v-if="documentos && documentos.documento3">
                        <label class="text-subtitle2">Constancia de Situación Fiscal</label>
                        <q-field dense outlined class="q-mt-xs full-width">

                            <template v-slot:control>
                                <div class="self-center full-width no-outline" tabindex="0">{{
                                    documentos.documento3.nombre_archivo }}</div>
                            </template>

                            <template v-slot:before>
                                <q-icon v-if="documentos.documento3.existe" color="green" name="mdi-check-circle" />
                                <q-icon v-else color="red" name="mdi-alert-circle" />
                            </template>

                            <template v-slot:after>
                                <q-btn v-if="documentos.documento3.existe" round dense flat color="green"
                                    icon="mdi-download" @click="descargarArchivo(documentos.documento3)" />
                                <q-btn v-if="documentos.documento3.existe" round dense flat color="red"
                                    icon="mdi-file-remove" @click="rechazarArchivo(documentos.documento3)" />
                            </template>
                        </q-field>
                    </div>

                    <div class="q-mb-md text-left" v-if="documentos && documentos.document4">
                        <label class="text-subtitle2">Comprobante de Domicilio</label>
                        <q-field dense outlined class="q-mt-xs full-width">

                            <template v-slot:control>
                                <div class="self-center full-width no-outline" tabindex="0">{{
                                    documentos.documento4.nombre_archivo }}</div>
                            </template>

                            <template v-slot:before>
                                <q-icon v-if="documentos.documento4.existe" color="green" name="mdi-check-circle" />
                                <q-icon v-else color="red" name="mdi-alert-circle" />
                            </template>

                            <template v-slot:after>
                                <q-btn v-if="documentos.documento4.existe" round dense flat color="green"
                                    icon="mdi-download" @click="descargarArchivo(documentos.documento4)" />
                                <q-btn v-if="documentos.documento4.existe" round dense flat color="red"
                                    icon="mdi-file-remove" @click="rechazarArchivo(documentos.documento4)" />
                            </template>
                        </q-field>
                    </div>

                    <div class="q-mb-md text-left" v-if="documentos && documentos.documento5">
                        <label class="text-subtitle2">Otro</label>
                        <q-field dense outlined class="q-mt-xs full-width">

                            <template v-slot:control>
                                <div class="self-center full-width no-outline" tabindex="0">{{
                                    documentos.documento5.nombre_archivo }}</div>
                            </template>

                            <template v-slot:before>
                                <q-icon v-if="documentos.documento5.existe" color="green" name="mdi-check-circle" />
                                <q-icon v-else color="red" name="mdi-alert-circle" />
                            </template>

                            <template v-slot:after>
                                <q-btn v-if="documentos.documento5.existe" round dense flat color="green"
                                    icon="mdi-download" @click="descargarArchivo(documentos.documento5)" />
                                <q-btn v-if="documentos.documento5.existe" round dense flat color="red"
                                    icon="mdi-file-remove" @click="rechazarArchivo(documentos.documento5)" />
                            </template>
                        </q-field>
                    </div>
                    <div align="right">
                        <q-btn outline icon="mdi-close" label="Cerrar" color="negative" class="q-mt-md"
                            @click="cerrarFormulario()" />
                    </div>
                </q-card>
            </div>

            <div :class="mostrarFormulario ? 'col-md-8 col-12' : 'col-12'">
                <q-table dense title="Clientes" class="shadow-1" :data="clientes" :loading="loading" :columns="columns"
                    color="primary" row-key="_id" :pagination="initialPagination">
                    <template v-slot:top-right>
                        <q-btn outline color="primary" icon="mdi-plus" label="Nuevo Cliente" @click="NuevoClientes()"
                            no-caps class=" q-my-md" />
                        <q-btn outline color="primary" icon="mdi-refresh" label="Consultar" @click="GetClientes()"
                            no-caps class=" q-my-md" />
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props" class="hover-fila">
                            <q-td key="rfc" :props="props" @click="verItem(props.row)">{{ props.row.rfc }}</q-td>
                            <q-td key="razon_social" :props="props" @click="verItem(props.row)">{{
                                props.row.razon_social
                            }}</q-td>
                            <q-td key="cp" :props="props" @click="verItem(props.row)">{{ props.row.cp }}</q-td>
                            <q-td key="regimen_fiscal" :props="props" @click="verItem(props.row)">{{
                                props.row.regimen_fiscal.regimenFiscal
                            }}</q-td>
                            <q-td key="usoCfdi" :props="props" @click="verItem(props.row)">{{
                                props.row.usoCfdi.usoCfdi }}</q-td>
                            <q-td key="metodoPago" :props="props" @click="verItem(props.row)">{{
                                props.row.metodoPago.metodoPago }}</q-td>
                            <q-td key="formaPago" :props="props" @click="verItem(props.row)">{{
                                props.row.formaPago.formaPago }}</q-td>
                            <q-td key="moneda" :props="props" @click="verItem(props.row)">{{
                                props.row.moneda.moneda }}</q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>
</template>
<script>
import axios from "axios";
import { QSpinnerClock } from 'quasar'
import moment from 'moment';
import PerfilCliente from "./PerfilCliente.vue";
export default {
    components: {
        PerfilCliente
    },
    data() {
        return {
            loading: false,
            mostrarFormulario: false,
            columns: [
                { name: 'rfc', label: 'RFC', field: 'rfc', align: 'center', sortable: true },
                { name: 'razon_social', label: 'Razón Social o Nombre de la Persona', field: 'razon_social', align: 'center', sortable: true },
                { name: 'cp', label: 'Código Postal', field: 'cp', align: 'center', sortable: true },
                { name: 'regimen_fiscal', label: 'Régimen Fiscal', field: 'regimen_fiscal', align: 'center', sortable: true },
                { name: 'usoCfdi', label: 'Uso del CFDI', field: 'usoCfdi', align: 'center', sortable: true },
                { name: 'metodoPago', label: 'Método de Pago', field: 'metodoPago', align: 'center', sortable: true },
                { name: 'formaPago', label: 'Forma de Pago', field: 'formaPago', align: 'center', sortable: true },
                { name: 'moneda', label: 'Moneda', field: 'moneda', align: 'center', sortable: true },
            ],
            initialPagination: {
                sortBy: 'nombre',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            clientes: [],
            documentos: null,

            clienteSelect: {
                nombre: '',
                apellidos: ''
            },
            dialogMotivoRechazo: false,
            motivoRechazo: '',
            documentoSelect: { tipo: '' },
            dialogNuevoCliente: false,
            form: null,

            regimenFiscalStore: [],
            formaPagoStore: [],
            metodoPagoStore: [],
            usoCfdiStore: [],
            regimenFiscal: [],
            monedaStore: [],

            dialogPerfilCliente: false
        }
    },
    mounted() {
    },
    computed: {
        adminStore() {
            return this.$store.state.auth.usuario;
        },
        ValidaRegimen() {
            let rfc = this.form.rfc
            console.log(rfc.length)
            if (rfc.length === 12) {
                this.regimenFiscal = [];
                let filtroRegimen = this.regimenFiscalStore.filter(f => f.moral === 'Sí');
                this.regimenFiscal = [...filtroRegimen]
                console.log('m', this.regimenFiscal)
                return 'M';
            } else if (rfc.length === 13) {
                this.regimenFiscal = [];
                let filtroRegimen = this.regimenFiscalStore.filter(f => f.fisica === 'Sí');
                this.regimenFiscal = [...filtroRegimen]
                console.log('f', this.regimenFiscal)
                if (rfc === 'XAXX010101000' || rfc === 'XEXX010101000') {
                    let b = filtroRegimen.find(f => f.clave === '616');
                    this.regimen_fiscal = b;
                }
                return 'F';
            }
            return "";
        },
    },
    created() {
        this.GetClientes();
        this.GetRegimenFiscal();
        this.GetUsoCfdi();
        this.GetMetodoPago();
        this.GetFormaPago();
        this.GetMoneda();
    },
    methods: {
        async GetClientes() {
            this.loading = true
            try {
                let respuesa = await axios.get('Configuracion/GetUsuariosDatosFiscales/')
                console.log(respuesa)
                this.clientes = respuesa.data
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        async verItem(item) {
            console.log(item)
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Consultando datos del cliente. Espere...', messageColor: 'white' })
            this.$store.state.auth.clienteStore = item
            this.dialogPerfilCliente = true
            this.$q.loading.hide()
        },
        descargarArchivo(documento) {
            const link = document.createElement('a');
            link.href = documento.archivo_base64;
            link.download = documento.nombre_archivo || 'archivo.pdf';
            link.click();
        },
        rechazarArchivo(item) {
            this.dialogMotivoRechazo = true
            this.documentoSelect = item
            this.motivoRechazo = ''
        },
        cerrarFormulario() {
            this.mostrarFormulario = false
            this.documentos = null

            this.clienteSelect = {
                nombre: '',
                apellidos: ''
            }
        },
        async PostRechazarDocumento() {
            const objeto = {
                _id: '',
                _id_administrador: this.adminStore._id,
                _id_usuario: this.clienteSelect._id,
                motivoRechazo: this.motivoRechazo,
                fechaRechazo: new Date().toISOString().slice(0, 10),
                documento: this.documentoSelect
            }
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Rechazando documento. Espere...', messageColor: 'white' })

            try {
                const resp = await axios.post(`Documentos/PutDocumentoRechazado/`, objeto);
                this.$q.loading.hide()
                if (resp.data.exito) {
                    this.$q.notify({ type: 'positive', message: `Se ha enviado el motivo de rechazo.` });
                    await this.verItem(this.clienteSelect);
                    this.dialogMotivoRechazo = false
                } else {
                    throw new Error();
                }
            } catch (err) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', message: `Error al guardar el documento.` });
            }
        },
        NuevoClientes() {
            this.form = {
                nombre: '',
                apellidos: '',
                email: '',
                telefono: '',
                rfc: '',
                razon_social: '',
                cp: '',
                fechaCreacion: moment().format('YYYY/MM/DD'),
                usoCfdi: {
                    usoCfdi: ''
                },
                regimen_fiscal: {
                    regimenFiscal: ''
                },
                metodoPago: {
                    metodoPago: ''
                },
                formaPago: {
                    formaPago: ''
                },
                moneda: {
                    moneda: 'MXN | Peso Mexicano',
                    clave: 'MXN',
                    descripcion: 'Peso Mexicano'
                }
            }
            this.dialogNuevoCliente = true
        },

        async PostNuevoCliente() {
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Guardando datos del Cliente. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post('Configuracion/PostNuevoCliente/', this.form)
                console.log(respuesa)
                this.$q.loading.hide()

                this.$q.notify({ position: 'top-right', type: 'positive', message: `Información guardada exitosamente.` })
                this.form._id_cliente = respuesa.data
                this.clientes.push(this.form)
            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ position: 'top-right', type: 'negative', message: error.data })
                console.log(error)
            }
        },

        async GetRegimenFiscal() {
            if (this.regimenFiscalStore.length == 0) {
                try {
                    let response = await axios.get("https://api-beta-erp.contago.com.mx/api/CatalogosSat/GetCatRegimenFiscalAsync/");
                    console.log('d', response.data)
                    this.regimenFiscalStore = response.data;
                } catch (error) {
                    console.log(error);
                }
            }
        },

        async GetUsoCfdi() {
            if (this.usoCfdiStore.length != 0) {
                return;
            } else {
                try {
                    let response = await axios.get('https://api-beta-erp.contago.com.mx/api/CatalogosSat/GetCatUsoCfdiAsync')
                    let x = response.data;
                    this.usoCfdiStore = [...x]
                } catch (error) {
                    console.log(error)
                }
            }
        },

        async GetMetodoPago() {
            if (this.metodoPagoStore.length != 0) {
                return;
            } else {
                try {
                    let response = await axios.get('https://api-beta-erp.contago.com.mx/api/CatalogosSat/GetCatMetodoPagoAsync')
                    let x = response.data;
                    this.metodoPagoStore = [...x]
                } catch (error) {
                    console.log(error)
                }
            }
        },

        async GetFormaPago() {
            if (this.formaPagoStore.length != 0) {
                return;
            } else {
                try {
                    let response = await axios.get('https://api-beta-erp.contago.com.mx/api/CatalogosSat/GetCatFormaPagoAsync')
                    let x = response.data;
                    this.formaPagoStore = [...x]
                } catch (error) {
                    console.log(error)
                }
            }
        },

        async GetMoneda() {
            if (this.monedaStore.length != 0) {
                return;
            } else {
                try {
                    let response = await axios.get('https://api-beta-erp.contago.com.mx/api/CatalogosSat/GetCatMonedaAsync')
                    let x = response.data;
                    this.monedaStore = [...x]
                } catch (error) {
                    console.log(error)
                }
            }
        },
    }
}
</script>
<style>
.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}
</style>